import { AnyAri } from '@atlassian/ari/any-ari';
import { ConfluenceSpaceAri } from '@atlassian/ari/confluence';
import { IdentityTeamAri } from '@atlassian/ari/identity';
import { JiraProjectAri } from '@atlassian/ari/jira';

import { logErrorMessage } from '../sentry';

export const getTeamId = (teamAri: string): string | undefined => {
	let teamId: string | undefined;

	const isIdentityTeamsAri = IdentityTeamAri.check(teamAri);

	if (isIdentityTeamsAri) {
		const identityTeamId = IdentityTeamAri.parse(teamAri).teamId;
		if (identityTeamId !== 'unidentified') {
			teamId = identityTeamId;
		} else {
			logErrorMessage('Team ID has value "unidentified" in getTeamId', { teamAri });
		}
	} else {
		logErrorMessage('Cannot parse IdentityTeamARI in getTeamId', { teamAri });
	}

	return teamId;
};

export const getTeamProfileUrl = (containerAri: string, teamAri: string): string | undefined => {
	let teamProfileUrl: string | undefined;
	const productPath = ConfluenceSpaceAri.check(containerAri)
		? 'wiki'
		: JiraProjectAri.check(containerAri)
			? 'jira'
			: undefined;

	let teamId: string | undefined;
	teamId = getTeamId(teamAri);
	if (productPath && teamId) {
		teamProfileUrl = `${window.location.origin}/${productPath}/people/team/${teamId}`;
	} else {
		logErrorMessage('Cannot create teamProfileUrl in getTeamProfileUrl', { containerAri, teamAri });
	}

	return teamProfileUrl;
};

export const getSiteId = (containerAri: string, options?: { enableLogging?: boolean }): string | undefined => {
	const { enableLogging = true } = options ?? {};
	const siteId = AnyAri.check(containerAri) && AnyAri.parse(containerAri).cloudId;

	if (!siteId) {
		if (enableLogging) {
			logErrorMessage('Cannot parse containerAri in getSiteId', { containerAri });
		}
		return;
	}

	return siteId;
};

export const getTeamAri = (teamId: string): string | undefined => {
	try {
		return IdentityTeamAri.create({
			teamId,
		}).toString();
	} catch (error) {
		logErrorMessage('Cannot create IdentityTeamAri in getTeamAri', { teamId });
	}
};
